import { get } from 'edrolo/domains/net';
import urlResolver from 'edrolo/utils/URLResolver';

// used by TopicGrid only
export const SchoolClassAPI = {
  fetchStudentLessonProgress(classId, studentId, lessonId) {
    const url = urlResolver.reverse('api:student-lesson-progress', {
      class_id: classId,
      student_id: studentId,
      lesson_id: lessonId,
    });
    return get(url, { transformBody: (body) => body.toJS() });
  },
};
